/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { SalesContractResponseDto } from '../models/sales-contract-response-dto';
import { contractsControllerCreate } from '../fn/contracts/contracts-controller-create';
import { ContractsControllerCreate$Params } from '../fn/contracts/contracts-controller-create';
import { contractsControllerDelete } from '../fn/contracts/contracts-controller-delete';
import { ContractsControllerDelete$Params } from '../fn/contracts/contracts-controller-delete';
import { contractsControllerFindByCode } from '../fn/contracts/contracts-controller-find-by-code';
import { ContractsControllerFindByCode$Params } from '../fn/contracts/contracts-controller-find-by-code';
import { contractsControllerFindByQuoteId } from '../fn/contracts/contracts-controller-find-by-quote-id';
import { ContractsControllerFindByQuoteId$Params } from '../fn/contracts/contracts-controller-find-by-quote-id';
import { contractsControllerFindByTenant } from '../fn/contracts/contracts-controller-find-by-tenant';
import { ContractsControllerFindByTenant$Params } from '../fn/contracts/contracts-controller-find-by-tenant';
import { contractsControllerFindByTenantAndId } from '../fn/contracts/contracts-controller-find-by-tenant-and-id';
import { ContractsControllerFindByTenantAndId$Params } from '../fn/contracts/contracts-controller-find-by-tenant-and-id';
import { contractsControllerFindByTenantAndIdWithPayments } from '../fn/contracts/contracts-controller-find-by-tenant-and-id-with-payments';
import { ContractsControllerFindByTenantAndIdWithPayments$Params } from '../fn/contracts/contracts-controller-find-by-tenant-and-id-with-payments';
import { contractsControllerUpdate } from '../fn/contracts/contracts-controller-update';
import { ContractsControllerUpdate$Params } from '../fn/contracts/contracts-controller-update';
import { SalesContractWithPaymentsResponseDto } from '../models/sales-contract-with-payments-response-dto';

@Injectable({ providedIn: 'root' })
export class SalesContractsService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contractsControllerCreate()` */
  static readonly ContractsControllerCreatePath = '/o2-sales/contracts/{tenant}';

  /**
   * Create a contract from an existing quote (copies all quote data including code, with optional batch payments).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractsControllerCreate$Response(params: ContractsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
    const obs = contractsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a contract from an existing quote (copies all quote data including code, with optional batch payments).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractsControllerCreate(params: ContractsControllerCreate$Params, context?: HttpContext): Observable<SalesContractResponseDto> {
    const resp = this.contractsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractResponseDto>): SalesContractResponseDto => r.body)
    );
  }

  /** Path part for operation `contractsControllerFindByTenant()` */
  static readonly ContractsControllerFindByTenantPath = '/o2-sales/contracts/tenant/{tenant}';

  /**
   * Get all contracts for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerFindByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByTenant$Response(params: ContractsControllerFindByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContractResponseDto>>> {
    const obs = contractsControllerFindByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all contracts for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerFindByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByTenant(params: ContractsControllerFindByTenant$Params, context?: HttpContext): Observable<Array<SalesContractResponseDto>> {
    const resp = this.contractsControllerFindByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesContractResponseDto>>): Array<SalesContractResponseDto> => r.body)
    );
  }

  /** Path part for operation `contractsControllerFindByTenantAndId()` */
  static readonly ContractsControllerFindByTenantAndIdPath = '/o2-sales/contracts/tenant/{tenant}/{id}';

  /**
   * Get a specific contract by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerFindByTenantAndId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByTenantAndId$Response(params: ContractsControllerFindByTenantAndId$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
    const obs = contractsControllerFindByTenantAndId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a specific contract by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerFindByTenantAndId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByTenantAndId(params: ContractsControllerFindByTenantAndId$Params, context?: HttpContext): Observable<SalesContractResponseDto> {
    const resp = this.contractsControllerFindByTenantAndId$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractResponseDto>): SalesContractResponseDto => r.body)
    );
  }

  /** Path part for operation `contractsControllerDelete()` */
  static readonly ContractsControllerDeletePath = '/o2-sales/contracts/tenant/{tenant}/{id}';

  /**
   * Delete a contract.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerDelete$Response(params: ContractsControllerDelete$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<void>> {
    const obs = contractsControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a contract.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerDelete(params: ContractsControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.contractsControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `contractsControllerUpdate()` */
  static readonly ContractsControllerUpdatePath = '/o2-sales/contracts/tenant/{tenant}/{id}';

  /**
   * Update a contract.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractsControllerUpdate$Response(params: ContractsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
    const obs = contractsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a contract.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractsControllerUpdate(params: ContractsControllerUpdate$Params, context?: HttpContext): Observable<SalesContractResponseDto> {
    const resp = this.contractsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractResponseDto>): SalesContractResponseDto => r.body)
    );
  }

  /** Path part for operation `contractsControllerFindByQuoteId()` */
  static readonly ContractsControllerFindByQuoteIdPath = '/o2-sales/contracts/by-quote/{quoteId}';

  /**
   * Get contract by quote ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerFindByQuoteId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByQuoteId$Response(params: ContractsControllerFindByQuoteId$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
    const obs = contractsControllerFindByQuoteId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get contract by quote ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerFindByQuoteId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByQuoteId(params: ContractsControllerFindByQuoteId$Params, context?: HttpContext): Observable<SalesContractResponseDto> {
    const resp = this.contractsControllerFindByQuoteId$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractResponseDto>): SalesContractResponseDto => r.body)
    );
  }

  /** Path part for operation `contractsControllerFindByCode()` */
  static readonly ContractsControllerFindByCodePath = '/o2-sales/contracts/tenant/{tenant}/by-code/{code}';

  /**
   * Get contract by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerFindByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByCode$Response(params: ContractsControllerFindByCode$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
    const obs = contractsControllerFindByCode(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get contract by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerFindByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByCode(params: ContractsControllerFindByCode$Params, context?: HttpContext): Observable<SalesContractResponseDto> {
    const resp = this.contractsControllerFindByCode$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractResponseDto>): SalesContractResponseDto => r.body)
    );
  }

  /** Path part for operation `contractsControllerFindByTenantAndIdWithPayments()` */
  static readonly ContractsControllerFindByTenantAndIdWithPaymentsPath = '/o2-sales/contracts/tenant/{tenant}/{id}/with-payments';

  /**
   * Get a contract with its payments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractsControllerFindByTenantAndIdWithPayments()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByTenantAndIdWithPayments$Response(params: ContractsControllerFindByTenantAndIdWithPayments$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractWithPaymentsResponseDto>> {
    const obs = contractsControllerFindByTenantAndIdWithPayments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a contract with its payments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractsControllerFindByTenantAndIdWithPayments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractsControllerFindByTenantAndIdWithPayments(params: ContractsControllerFindByTenantAndIdWithPayments$Params, context?: HttpContext): Observable<SalesContractWithPaymentsResponseDto> {
    const resp = this.contractsControllerFindByTenantAndIdWithPayments$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractWithPaymentsResponseDto>): SalesContractWithPaymentsResponseDto => r.body)
    );
  }

}
